import { Injectable } from '@angular/core';
declare let THREE: any;
import { SceneUtilsService } from './scene-utils.service';
import { RendererService } from './renderer.service';
import { RoomStateManagerService } from './room-state-manager.service';
import { ProjectManagerService } from './project-manager.service';


@Injectable()
export class ScreenshotPreprocessService {

  constructor(private sceneUtils: SceneUtilsService,
              private rendererSrvc: RendererService,
              private roomStateManager: RoomStateManagerService,
              private projectSrvc: ProjectManagerService) { }

  flipVertically(uint8Array, w, h) {
    const canvas = document.createElement('canvas');
    const cnx = canvas.getContext('2d');
    const array = new Uint8ClampedArray(uint8Array);
    const imageData = new ImageData(array, w, h);
    canvas.width = w;
    canvas.height = h;
    cnx.putImageData(imageData, 0, 0);
    cnx.scale(1, -1);
    cnx.drawImage(canvas, 0, -h);
    return canvas;
  }

  clipImage(img, offsetX, offsetY, w, h) {
    const canvas = document.createElement('canvas');
    const cnx = canvas.getContext('2d');
    canvas.width = w;
    canvas.height = h;
    cnx.drawImage(img, offsetX, offsetY, w, h, 0, 0, w, h);
    return canvas;
  }

  clipEmptySpace2D() {

    const box3 = new THREE.Box3().setFromPoints(this.roomStateManager.getPoints());
    const size = box3.getSize(new THREE.Vector3());
    const center = box3.getCenter(new THREE.Vector3());
    const space = 20;

    let topLeft = center.clone();
    topLeft.x -= size.x / 2 + space;
    topLeft.z -= size.z / 2 + space;
    topLeft = this.sceneUtils.worldToScreen(new THREE.Vector3(topLeft.x, 0, topLeft.z));

    let bottomRight = center.clone();
    bottomRight.x += size.x / 2 + space;
    bottomRight.z += size.z / 2 + space;
    bottomRight = this.sceneUtils.worldToScreen(new THREE.Vector3(bottomRight.x, 0, bottomRight.z));

    const clipWidth = Math.ceil(bottomRight.x - topLeft.x);
    const clipHeight = Math.ceil(bottomRight.y - topLeft.y);
    const x = Math.ceil(topLeft.x);
    const y = Math.ceil(topLeft.y);

    const sceneCanvas = this.rendererSrvc.getCanvas();
    const sceneCanvasWidth = sceneCanvas.width;
    const sceneCanvasHeight = sceneCanvas.height;
    const sceneCanvasCnx = this.rendererSrvc.getContext();

    const pixelData = new Uint8Array(sceneCanvasWidth * sceneCanvasHeight * 4);
    sceneCanvasCnx.readPixels(0, 0, sceneCanvasWidth, sceneCanvasHeight, sceneCanvasCnx.RGBA, sceneCanvasCnx.UNSIGNED_BYTE, pixelData);

    const flipped = this.flipVertically(pixelData, sceneCanvasWidth, sceneCanvasHeight);
    const clipped = this.clipImage(flipped, x, y, clipWidth, clipHeight);

    return clipped.toDataURL();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/screenshot-preprocess.service.ts